export const types = {
  SET_USER_ORGANIZATION: 'SET_USER_ORGANIZATION',
  SET_USER_ORGANIZATIONS: 'SET_USER_ORGANIZATIONS',
};
